import { Container } from '../atoms'
import { View } from 'react-native'
import { composeStyle } from '@linqpal/common-frontend/src/helpers'
import React from 'react'

interface DotsProps {
  numberOfDots?: number
  style?: any
  dotSize?: number
  color?: string
  space?: number
  containerProps?: any
  dotStyle?: any
  testID?: string
}

export const Dots = ({
  numberOfDots = 3,
  style,
  dotSize = 3,
  color = 'black',
  space = 2,
  containerProps,
  dotStyle,
  testID = 'dots',
}: DotsProps) => {
  return (
    <Container
      center
      row
      style={composeStyle({ margin: 'auto' }, style)}
      {...containerProps}
    >
      {Array.from(Array(numberOfDots)).map((_, index) => (
        <View
          key={index}
          style={composeStyle(
            {
              height: dotSize,
              width: dotSize,
              borderRadius: dotSize,
              backgroundColor: color,
              margin: space,
            },
            dotStyle,
          )}
          testID={`${testID}_${index}`}
        />
      ))}
    </Container>
  )
}
